import { useCallback, useState } from "react";
import type { PressEvent } from "react-aria";

import { useIsMounted } from "../../hooks/useIsMounted.ts";
import type { ActionButtonProps } from "./ActionButton.tsx";

export const useAsyncLoading = (onPress?: ActionButtonProps["onPress"]) => {
  const isMounted = useIsMounted();
  const [isAsyncLoading, setAsyncLoading] = useState(false);
  const handlePress = useCallback(
    (event: PressEvent) => {
      const response = onPress?.(event);
      if (typeof (response as Promise<unknown> | undefined)?.then === "function") {
        setAsyncLoading(true);
        return (response as Promise<unknown>)
          .then(() => {
            if (isMounted) setAsyncLoading(false);
            return response;
          })
          .catch((error: Error) => {
            if (isMounted) setAsyncLoading(false);
            throw error;
          });
      }

      return response;
    },
    [onPress, isMounted],
  );

  return { handlePress, isAsyncLoading };
};
